'use client';

import { formatDate } from '@spikemark/ui/utils/format';
import { FC } from 'react';
import { useMetadataContext } from '../../providers/metadata-provider';
export const PrintTitle: FC<{
  className?: string;
}> = ({
  className
}) => {
  const {
    printTitle
  } = useMetadataContext();
  return <div className="hidden print:block" data-sentry-component="PrintTitle" data-sentry-source-file="print-title.tsx">
      {printTitle && <h4 className={className}>{printTitle}</h4>}
      <div className="text-gray-500 text-2xs">Date Generated: {formatDate(new Date())}</div>
    </div>;
};